import { render, staticRenderFns } from "./TriageForm.vue?vue&type=template&id=2eea37e1&"
import script from "./TriageForm.vue?vue&type=script&lang=js&"
export * from "./TriageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports